export default __webpack_public_path__ + "static/media/debate_2.5210734d.JPG";